import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScullyRoute, ScullyRoutesService } from '@scullyio/ng-lib';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import ClearcalsIcons from 'app/icons/icons.data';

@Component({
	selector: 'clearcals-blogs',
	templateUrl: './blogs.component.html',
	styleUrls: ['./blogs.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class BlogsComponent implements OnInit {
	// icons
	userIcon = ClearcalsIcons.getIcon('user');
	calenderIcon = ClearcalsIcons.getIcon('calender');

	posts$: Observable<ScullyRoute[]>;

	constructor(private scully: ScullyRoutesService) {}

	ngOnInit(): void {
		this.posts$ = this.scully.available$.pipe(
			map((routeList) => {
				return routeList.filter(
					(route: ScullyRoute) =>
						route.route.startsWith(`/blogs/`) && route.sourceFile.endsWith('.md'),
				);
			}),
			map((blogs) => {
				const copyOfBlogs = blogs.map((blog) => {
					blog.date = blog.lastModified ? new Date(blog.lastModified) : new Date(blog.createdDate);
					return blog;
				});
				return copyOfBlogs.sort((a, b) => {
					return b.date.getTime() - a.date.getTime();
				});
			}),
		);
	}
}
